import { z } from 'zod';

export const ForecastFeedbackWhenSchema = z.object({
  whenDay: z.string().min(1),
  whenTime: z.date(),
});

const ForecastFeedbackFormSchema = ForecastFeedbackWhenSchema.extend({
  waveSize: z.string().min(1),
  conditions: z.string().min(1),
  wind: z.string().min(1),
  notes: z.string().max(280).optional(),
});

export default ForecastFeedbackFormSchema;
